import React, { useState } from "react";
import "containers/CartOverview/CartFooter/CartFooter.css";
import useCart from "hooks/useCart";
import PropTypes from "prop-types";
import Button from "components/Button/Button";
import BottomUpModal from "components/BottomUpModal/BottomUpModal";
import LoginForm from "components/LoginForm/LoginForm";
import { getURLDetails, renderPriceWithSymbol } from "utils/commonMethods";
import { Link } from "react-router-dom";
import { APP_ROUTES } from "constants/routes";
import { withRouter } from "react-router";
import useAuthentication from "hooks/useAuthentication";
import { useSelector } from "react-redux";
import { PAYMENT_METHODS, VM_STATUS_ONLINE } from "constants/constants";
import { getUserHashToken, getUserPhone } from "utils/commonMethods";
import AlertModal from "components/AlertModal/AlertModal";
import { API_KEYS } from "constants/apiEndpoints";
import LoadingButton from "components/LoadingButton/LoadingButton";
//Handles user authentication & action buttons of cart page.
function CartFooter({
  componentTexts,
  showDispenseLoader,
  history,
  onPaymentDispenseSuccess,
  onPaymentDispenseLaterSuccess,
  onPaymentFailure,
}) {
  const [showUserLoginModal, setShowUserLoginModal] = useState(false);
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  const { userIsLoggedIn } = useAuthentication();
  const { currentCartItems } = useCart();
  const cUID = useSelector((state) => state.orderReducer.cUID); //Cart Unique Identifier
  const cartCouponDetails = useSelector(
    (state) => state.cartReducer.couponDetails
  );
  //Checking VM online status whether its true or false

  let vendingMachineStatus = useSelector(
    (state) => state.vmDetailsReducer.is_online
  );

  let createApiPayload = {
    cUID,
    id: vendingMachineDetails.id,
    items: currentCartItems.map((element) => ({
      iQty: element.quantity,
      iUID: element.item.iUID,
      sid: element.item.sid,
    })),
    uuid: vendingMachineDetails.uuid,
    transaction_origin: 2,
    payMethod: null,
    time: new Date().getTime(),
    query: getURLDetails(),
    // phone_no: getUserPhone(),
    // hash: getUserHashToken(),
  };

  //If VM status is not online
  if (vendingMachineStatus !== true) {
    return (
      <AlertModal
        open={true}
        modalTitle={VM_STATUS_ONLINE.TITLE}
        modalDescription={VM_STATUS_ONLINE.DESCRPTION}
      ></AlertModal>
    );
  }
  const toggleUserLoginModal = function () {
    return setShowUserLoginModal(!showUserLoginModal);
  };

  const handleDispenseNow = function (response) {
    if (response.oUID && response.payment_gateway === 5 && response.cUID) {
      onPaymentDispenseSuccess(response.cUID, response.oUID);
    } else {
      onPaymentFailure();
    }
  };
  const handleDispenseLater = function (response) {
    if (response.oUID && response.payment_gateway === 5 && response.cUID) {
      onPaymentDispenseLaterSuccess(response.cUID, response.oUID);
    } else {
      onPaymentFailure();
    }
  };
  //Do not show footer if there are no products in cart.
  if (currentCartItems.length === 0) {
    return <React.Fragment></React.Fragment>;
  }

  return (
    <div className="cart-footer">
      <div className="cart-footer__buy-overview">
        {/* <h4 className="sub-head cart-footer__sub-total-lable">Sub total :</h4> */}
        {/* <span className="sub-head cart-footer__sub-total-price">
          {renderPriceWithSymbol(cartTotalPrice)}
        </span> */}
        {/* {totalDiscountPrice > 0 && (
          <React.Fragment>
            <h4 className="sub-head cart-footer__discount-label">
              {componentTexts.cart_page_discount_label}
            </h4>
            <span className="sub-head cart-footer__discount-price">
              -{renderPriceWithSymbol(totalDiscountPrice)}
            </span>
          </React.Fragment>
        )} */}
      </div>
      <hr />
      <div className="cart-footer__checkout">
        {/* <Button
          className="color-blue"
          loaderApiKey={API_KEYS.CREATE_CART}
          apiRequestBody={createApiPayload}
          onClick={handleDispenseNow}
        >
          {componentTexts.cart_page_checkout_button_text}
        </Button> */}
        {showDispenseLoader ? (
          <LoadingButton />
        ) : (
          <Button
            className="color-blue"
            loaderApiKey={API_KEYS.CREATE_CART}
            apiRequestBody={createApiPayload}
            onClick={handleDispenseLater}
          >
            {componentTexts.cart_page_checkout_button_text}
          </Button>
        )}
        {/* <p>(use Pick up code to dispense item later, within 10 minutes)</p> */}
        <p className="color-blue">
          You will receive a <b>Pickup Code</b> , which you need to enter on the
          machine screen to collect your items
        </p>
        <Button onClick={() => history.push(APP_ROUTES.HOME_PAGE.url)}>
          {componentTexts.cart_page_add_more_button_text}
        </Button>
      </div>

      <BottomUpModal
        open={showUserLoginModal}
        closeHandler={toggleUserLoginModal}
      >
        {showUserLoginModal && <LoginForm />}
      </BottomUpModal>
    </div>
  );
}

CartFooter.propTypes = {
  componentTexts: PropTypes.object.isRequired,
};

export default withRouter(CartFooter);
